import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

export default class TooltipContent extends Component {
  static propTypes = {
    position: PropTypes.object.isRequired,
    children: PropTypes.element.isRequired,
    tooltipRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(Element) })
    ])
  }

  constructor(props) {
    super(props)

    this.portal = document.getElementById('tooltips')
  }

  render() {
    const { position, children, tooltipRef } = this.props

    return (
      ReactDOM.createPortal(
        <div className="tooltip__content" ref={tooltipRef} style={{ ...position }}>{children}</div>,
        this.portal
      )
    )
  }
}
